import React, { useState } from 'react'
import Spinner from '../reusables/spinner';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { decline_supplier } from '../../redux/actions/adminActions';

function DeclineModal({ show, handleClose, users, decline, accessToken }) {


    const [isLoading,
        setIsLoading] = useState(false)

    const handleLoading = () => {
        setIsLoading(true);
    }

    const handleDecline = id => {
        handleLoading();
        decline(id, accessToken, handleClose);
    }

    return (
        <Modal show={ show } onHide={ handleClose } centered>
            <div className="icon--tiny isClickable closeModal" onClick={ handleClose }>
                <i class="ri-close-line sectionText--small"></i>
            </div>
            <div className="sectionHeight--mid center">
                <div className="w-100 vAlign">
                    <h2 className="sectionText--mid">Are you sure you want to decline { ' ' } { users?.length > 1 ? 'these' : 'this' } { ' ' } user{ users?.length > 1 && 's' }?</h2>

                    <div className="pt-3 center">

                        { isLoading
                            ? <div className='center'>
                                <Spinner dark />
                            </div>
                            : <div>
                                <button className="btn__filled mx-2 hasRadius" onClick={ handleClose }>No, Cancel</button>
                                <button className="btn__transparent" onClick={ () => handleDecline(users) }>Yes, Decline</button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </Modal>
    )
}

const mapStateToProps = (state) => ({
    accessToken: state.admin.token
})

const mapDispatchToProps = (dispatch) => ({
    decline: (id, token, success) => dispatch(decline_supplier(id, token, success))
})


export default connect(mapStateToProps, mapDispatchToProps)(DeclineModal)
